import ImpactMetrics from './ImpactMetrics';

export default ImpactMetrics;
